import { render, staticRenderFns } from "./CRUDServicos.vue?vue&type=template&id=7a8c1c81&"
import script from "./CRUDServicos.vue?vue&type=script&lang=js&"
export * from "./CRUDServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports